const routes = {
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    ADMIN_USERS: '/adminusers',
    CLASSIC_USERS: '/classicuser',
    CREATORS: '/creators',
    PRODUCTS: '/products',
    GIFTS: '/gifts',
    ITEMS: '/linkitems',
    SELFIES: '/selfies',
    CART: '/usercart',
    BRANDS: '/brands',
    ROLES: '/role',
    CREDIT_CODES: '/creditcode',
    NOTIFICATION: '/notification',
    CREATORS_CART: '/creatorscart',
    CUSTOMER_CART: '/customercart',
    PROFILE: '/profile',

    // Newly Added
    CAMPAIGN: '/campaign',
    FINANCES: '/finances',
    ACTIVITY: '/activity',
    GAME_CONTEST: '/gamecontest',
    TICKET: '/ticket',
    RAPPORT: '/rapport',
    BRIEFS_RULES: '/briefsrules',
    API_CONNECT: '/apiconnect',
    ABOUT: '/about'
}
export default routes;
